module.exports = __webpack_public_path__ + "static/ts-acc-app2.83a035bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ts-acc-app2.png
// module id = 105
// module chunks = 35783957827783 227738586966018